module.exports = __webpack_public_path__ + "img/law4.253fe4d2.jpg";